/* global G */
import { curry } from 'lib/util'
import { capitalizeFirstLetter } from 'lib/util/string'
import statuses from 'model/equipment/collection/installationReport'

/**
 * Translates and returns the list of invitable {@link roles}.
 *
 * @param {Gaia.AppModule.Spec} module            the current module object composition
 * @param {Gaia.Component} component              the object composition of the component that
 *                                                triggered the event
 * @param {Gaia.PlatformEvent|string} eventOrKey  the event or the key of the role to obtain
 * @returns {Array} countries
 */
const listInstallationReportStatus = (module, component, eventOrKey) => {
  const key = eventOrKey?.detail?.key || eventOrKey
  const scope = key ? statuses.filter(item => item.key === key) : statuses

  return scope.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `installation.${item.key}`,
      {
        ns: 'equipmentInformation',
        _key: `installation.${item.key}`,
        defaultValue: item.value,
      },
    ),
  }))
}

export default curry(listInstallationReportStatus)
